/* Navigation owns header state; all listeners are released on section unload. */
(function () {
  'use strict';
  Nowar.register('navigation', '#site-header', function(root, signal) {
    function on(target, name, handler, options) { target.addEventListener(name, handler, Object.assign({}, options, {signal:signal})); }
  /* ----- Header scroll state ----- */
  var header = root;
  var hero   = document.querySelector('.hero, .hero-cine');
  function onScroll(){
    if (!header) return;
    if (!hero || !hero.isConnected) hero = document.querySelector('.hero, .hero-cine');
    var threshold = 10;
    if (hero && hero.classList.contains('hero-cine')) {
      threshold = Math.max(0, hero.offsetHeight - 80);
    } else if (hero && hero.classList.contains('hero--home')) {
      threshold = Math.max(0, hero.getBoundingClientRect().bottom + window.scrollY - header.offsetHeight);
    }
    header.classList.toggle('scrolled', window.scrollY > threshold);

    // Newsletter FAB reveals once the Philosophy (or first non-hero) section enters view
    var nlFab = document.getElementById('nl-fab');
    var trigger = document.querySelector('[data-nl-trigger]');
    if (nlFab) {
      // Pages without a marker still need a reachable newsletter launcher.
      var triggerTop = trigger ? trigger.getBoundingClientRect().top :
        (hero ? hero.getBoundingClientRect().bottom : window.innerHeight - window.scrollY);
      nlFab.classList.toggle('show', triggerTop < window.innerHeight * 0.85);
    }
  }
  on(window, 'scroll', onScroll, {passive:true});
  on(window, 'resize', onScroll);
  onScroll();

  /* ----- Mobile drawer ----- */
  var drawer = document.getElementById('mobile-drawer');
  var toggleBtn = document.querySelector('[data-drawer-open]');
  var drawerPanel = drawer && drawer.querySelector('.drawer__panel');
  var drawerPreviousFocus = null;

  function closeMobileDrawer(restoreFocus){
    if (!drawer || !drawer.classList.contains('open')) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('drawer-lock');
    if (restoreFocus !== false && drawerPreviousFocus && drawerPreviousFocus.focus) drawerPreviousFocus.focus();
  }

  function openMobileDrawer(){
    if (!drawer) return;
    drawerPreviousFocus = document.activeElement;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('drawer-lock');
    window.requestAnimationFrame(function(){
      var closeButton = drawer.querySelector('.drawer__close');
      if (closeButton) closeButton.focus();
      else if (drawerPanel) drawerPanel.focus();
    });
  }

  if (drawer && toggleBtn) {
    on(toggleBtn, 'click', openMobileDrawer);
    drawer.querySelectorAll('[data-drawer-close]').forEach(function(el){
      on(el, 'click', function(){ closeMobileDrawer(true); });
    });
    on(document, 'keydown', function(event){
      if (event.key === 'Escape' && drawer.classList.contains('open')) closeMobileDrawer(true);
    });

  }

  /* ----- Location and language dialog ----- */
  var localizationDialog = document.getElementById('localization-dialog');
  if (localizationDialog && typeof localizationDialog.showModal === 'function') {
    var localizationOpeners = document.querySelectorAll('[data-localization-open]');
    var localizationClose = localizationDialog.querySelector('[data-localization-close]');
    var localizationCountry = localizationDialog.querySelector('[data-localization-country]');
    var localizationLanguage = localizationDialog.querySelector('[data-localization-language]');
    var localizationLanguageSelect = localizationDialog.querySelector('[data-localization-language-select]');
    var localizationPreviousFocus = null;

    function updateLocalizationLanguage(){
      var isFrance = localizationCountry && localizationCountry.value === 'FR';
      if (localizationLanguage) localizationLanguage.hidden = !isFrance;
      if (!isFrance && localizationLanguageSelect) localizationLanguageSelect.value = 'en';
    }

    localizationOpeners.forEach(function(opener){
      on(opener, 'click', function(){
        localizationPreviousFocus = opener;
        updateLocalizationLanguage();
        localizationDialog.showModal();
      });
    });
    if (localizationClose) on(localizationClose, 'click', function(){ localizationDialog.close(); });
    if (localizationCountry) on(localizationCountry, 'change', updateLocalizationLanguage);
    on(localizationDialog, 'click', function(event){
      if (event.target === localizationDialog) localizationDialog.close();
    });
    on(localizationDialog, 'close', function(){
      if (localizationPreviousFocus) localizationPreviousFocus.focus();
    });
  }


  on(document, 'nowar:drawer-close', function(){ closeMobileDrawer(false); });
  return function(){ document.body.classList.remove('drawer-lock'); };
  });
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('in'); revealObserver.unobserve(entry.target); }
    });
  }, {threshold: 0.08}) : null;
  Nowar.register('reveal', '.reveal, .post, .cell', function(element) {
    if (!revealObserver) { element.classList.add('in'); return; }
    revealObserver.observe(element);
    return () => revealObserver.unobserve(element);
  });
})();
